
import { faArchway } from '@fortawesome/pro-light-svg-icons/faArchway'
import { faAudioDescription } from '@fortawesome/pro-light-svg-icons/faAudioDescription'
import { faBriefcase } from '@fortawesome/pro-light-svg-icons/faBriefcase'
import { faCameraMovie } from '@fortawesome/pro-light-svg-icons/faCameraMovie'
import { faCar } from '@fortawesome/pro-light-svg-icons/faCar'
import { faChalkboardTeacher } from '@fortawesome/pro-light-svg-icons/faChalkboardTeacher'
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog'
import { faCogs } from '@fortawesome/pro-light-svg-icons/faCogs'
import { faCommentsAlt } from '@fortawesome/pro-light-svg-icons/faCommentsAlt'
import { faCommentSmile } from '@fortawesome/pro-light-svg-icons/faCommentSmile'
import { faDesktop } from '@fortawesome/pro-light-svg-icons/faDesktop'
import { faFileInvoiceDollar } from '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar'
import { faForklift } from '@fortawesome/pro-light-svg-icons/faForklift'
import { faGlasses } from '@fortawesome/pro-light-svg-icons/faGlasses'
import { faGlobeAsia } from '@fortawesome/pro-light-svg-icons/faGlobeAsia'
import { faHandHeart } from '@fortawesome/pro-light-svg-icons/faHandHeart'
import { faHandPaper } from '@fortawesome/pro-light-svg-icons/faHandPaper'
import { faHandSparkles } from '@fortawesome/pro-light-svg-icons/faHandSparkles'
import { faHatChef } from '@fortawesome/pro-light-svg-icons/faHatChef'
import { faHouse } from '@fortawesome/pro-light-svg-icons/faHouse'
import { faLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb'
import { faMoneyBill } from '@fortawesome/pro-light-svg-icons/faMoneyBill'
import { faNetworkWired } from '@fortawesome/pro-light-svg-icons/faNetworkWired'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPhoneRotary } from '@fortawesome/pro-light-svg-icons/faPhoneRotary'
import { faPhotoVideo } from '@fortawesome/pro-light-svg-icons/faPhotoVideo'
import { faPiggyBank } from '@fortawesome/pro-light-svg-icons/faPiggyBank'
import { faScrewdriver } from '@fortawesome/pro-light-svg-icons/faScrewdriver'
import { faShield } from '@fortawesome/pro-light-svg-icons/faShield'
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons/faShoppingCart'
import { faStethoscope } from '@fortawesome/pro-light-svg-icons/faStethoscope'
import { faTasks } from '@fortawesome/pro-light-svg-icons/faTasks'
import { faTools } from '@fortawesome/pro-light-svg-icons/faTools'
import { faTruck } from '@fortawesome/pro-light-svg-icons/faTruck'
import { faUniversalAccess } from '@fortawesome/pro-light-svg-icons/faUniversalAccess'
import { faUserAlt } from '@fortawesome/pro-light-svg-icons/faUserAlt'
import { faUserCog } from '@fortawesome/pro-light-svg-icons/faUserCog'
import { faUserHardHat } from '@fortawesome/pro-light-svg-icons/faUserHardHat'
import { faUserNurse } from '@fortawesome/pro-light-svg-icons/faUserNurse'
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
import { faUtensilsAlt } from '@fortawesome/pro-light-svg-icons/faUtensilsAlt'
import { faWarehouse } from '@fortawesome/pro-light-svg-icons/faWarehouse'

import RJA_FOOTER_LOGO from '../../../../portals/static/portals/rja_entry/home/rja_logo_footer.svg'

export const FOOTER_LOGO = RJA_FOOTER_LOGO
export const FOOTER_PHONE = '0800-4161-411'
export const FOOTER_PHONE_AT = '0800-28-15-11'
export const FOOTER_NAV = [{
  title: 'AGB',
  href: '/agb/'
}, {
  title: 'Impressum',
  href: '/impressum/'
}, {
  title: 'Datenschutz',
  href: '/datenschutz/'
}]

export const HOMEPAGE_QUICKLINKS = [
  {
    name: 'Bank',
    title: 'Bank Jobs',
    href: '/jobangebote/bank/',
    icon: faPiggyBank
  },
  {
    name: 'Marketing',
    title: 'Marketing Jobs',
    href: '/jobangebote/marketing/',
    icon: faAudioDescription
  },
  {
    name: 'IT',
    title: 'IT Jobs',
    href: '/jobangebote/it/',
    icon: faDesktop
  },
  {
    name: 'Logistik',
    title: 'Logistik Jobs',
    href: '/jobangebote/logistik/',
    icon: faTruck
  },
  {
    name: 'Vertrieb',
    title: 'Vertrieb Jobs',
    href: '/jobangebote/vertrieb/',
    icon: faCommentSmile
  },
  {
    name: 'Ingenieur',
    title: 'Ingenieur Jobs',
    href: '/jobangebote/ingenieur/',
    icon: faCog
  },
  {
    name: 'Öffentlicher Dienst',
    title: 'Öffentlicher Dienst Jobs',
    href: '/jobangebote/oeffentlicher-dienst/',
    icon: faArchway
  },
  {
    name: 'Lager',
    title: 'Lager Jobs',
    href: '/jobangebote/lager/',
    icon: faWarehouse
  },
  {
    name: 'Gastronomie',
    title: 'Gastronomie Jobs',
    href: '/jobangebote/gastronomie/',
    icon: faHatChef
  },
  {
    name: 'Medien',
    title: 'Medien Jobs',
    href: '/jobangebote/medien/',
    icon: faPhotoVideo
  },
  {
    name: 'Consulting',
    title: 'Consulting Jobs',
    href: '/jobangebote/consulting/',
    icon: faCommentsAlt
  },
  {
    name: 'Management',
    title: 'Management Jobs',
    href: '/jobangebote/management/',
    icon: faNetworkWired
  },
  {
    name: 'Personal',
    title: 'Personal Jobs',
    href: '/jobangebote/personal/',
    icon: faUserAlt
  },
  {
    name: 'Assistenz',
    title: 'Assistenz Jobs',
    href: '/jobangebote/assistenz/',
    icon: faTasks
  },
  {
    name: 'Handwerk',
    title: 'Handwerk Jobs',
    href: '/jobangebote/handwerk/',
    icon: faHandPaper
  },
  {
    name: 'Umwelt',
    title: 'Umwelt Jobs',
    href: '/jobangebote/umwelt/',
    icon: faGlobeAsia
  },
  {
    name: 'Finanzen',
    title: 'Finanzen Jobs',
    href: '/jobangebote/finanzen/',
    icon: faMoneyBill
  },
  {
    name: 'Bau',
    title: 'Bau Jobs',
    href: '/jobangebote/bau/',
    icon: faUserHardHat
  },
  {
    name: 'Medizin',
    title: 'Medizin Jobs',
    href: '/jobangebote/medizin/',
    icon: faStethoscope
  },
  {
    name: 'Bildung',
    title: 'Bildung Jobs',
    href: '/jobangebote/bildung/',
    icon: faChalkboardTeacher
  },
  {
    name: 'Service',
    title: 'Service Jobs',
    href: '/jobangebote/service/',
    icon: faUsers
  },
  {
    name: 'Produktion',
    title: 'Produktion Jobs',
    href: '/jobangebote/produktion/',
    icon: faCameraMovie
  },
  {
    name: 'Sozialpädagogik',
    title: 'Sozialpädagogik Jobs',
    href: '/jobangebote/sozialpaedagogik/',
    icon: faHandHeart
  },
  {
    name: 'Sekretariat',
    title: 'Sekretariat Jobs',
    href: '/jobangebote/sekretariat/',
    icon: faPhoneRotary
  },
  {
    name: 'Verkäufer',
    title: 'Verkäufer Jobs',
    href: '/jobangebote/verkaeufer/',
    icon: faCommentSmile
  },
  {
    name: 'Erzieher',
    title: 'Erzieher Jobs',
    href: '/jobangebote/erzieher/',
    icon: faGlasses
  },
  {
    name: 'Fahrer',
    title: 'Fahrer Jobs',
    href: '/jobangebote/fahrer/',
    icon: faCar
  },
  {
    name: 'Vertriebsinnendienst',
    title: 'Vertriebsinnendienst Jobs',
    href: '/jobangebote/vertriebsinnendienst/',
    icon: faNetworkWired
  },
  {
    name: 'Koch',
    title: 'Koch Jobs',
    href: '/jobangebote/koch/',
    icon: faUtensilsAlt
  },
  {
    name: 'Hausmeister',
    title: 'Hausmeister Jobs',
    href: '/jobangebote/hausmeister/',
    icon: faHouse
  },
  {
    name: 'Servicetechniker',
    title: 'Servicetechniker Jobs',
    href: '/jobangebote/servicetechniker/',
    icon: faTools
  },
  {
    name: 'Industriemechaniker',
    title: 'Industriemechaniker Jobs',
    href: '/jobangebote/industriemechaniker/',
    icon: faCogs
  },
  {
    name: 'Einkäufer',
    title: 'Einkäufer Jobs',
    href: '/jobangebote/einkaeufer/',
    icon: faShoppingCart
  },
  {
    name: 'Elektriker',
    title: 'Elektriker Jobs',
    href: '/jobangebote/elektriker/',
    icon: faLightbulb
  },
  {
    name: 'Reinigungskraft',
    title: 'Reinigungskraft Jobs',
    href: '/jobangebote/reinigungskraft/',
    icon: faHandSparkles
  },
  {
    name: 'Bürokauffrau',
    title: 'Bürokauffrau Jobs',
    href: '/jobangebote/buerokauffrau/',
    icon: faShield
  },
  {
    name: 'Techniker',
    title: 'Techniker Jobs',
    href: '/jobangebote/techniker/',
    icon: faScrewdriver
  },
  {
    name: 'Staplerfahrer',
    title: 'Staplerfahrer Jobs',
    href: '/jobangebote/staplerfahrer/',
    icon: faForklift
  },
  {
    name: 'Zerspanungsmechaniker',
    title: 'Zerspanungsmechaniker Jobs',
    href: '/jobangebote/zerspanungsmechaniker/',
    icon: faUserCog
  },
  {
    name: 'Call Center',
    title: 'Call Center Jobs',
    href: '/jobangebote/call-center/',
    icon: faPhone
  },
  {
    name: 'Servicekraft',
    title: 'Servicekraft Jobs',
    href: '/jobangebote/servicekraft/',
    icon: faUniversalAccess
  },
  {
    name: 'Sachbearbeitung',
    title: 'Sachbearbeitung Jobs',
    href: '/jobangebote/sachbearbeitung/',
    icon: faTasks
  },
  {
    name: 'Produktionshelfer',
    title: 'Produktionshelfer Jobs',
    href: '/jobangebote/produktionshelfer/',
    icon: faUsers
  },
  {
    name: 'Pflegefachkraft',
    title: 'Pflegefachkraft Jobs',
    href: '/jobangebote/pflegefachkraft/',
    icon: faUserNurse
  },
  {
    name: 'Key Account Manager',
    title: 'Key Account Manager Jobs',
    href: '/jobangebote/key-account-manager/',
    icon: faFileInvoiceDollar
  },
  {
    name: 'Kaufmann',
    title: 'Kaufmann Jobs',
    href: '/jobangebote/kaufmann/',
    icon: faBriefcase
  },
  {
    name: 'Buchhalter',
    title: 'Buchhalter Jobs',
    href: '/jobangebote/buchhalter/',
    icon: faFileInvoiceDollar
  },
  {
    name: 'Sozialarbeiter',
    title: 'Sozialarbeiter Jobs',
    href: '/jobangebote/sozialarbeiter/',
    icon: faHandHeart
  }
]
